import React from 'react';
import { block } from '../../utils';
import { useTrackAssetContext } from './TrackAssetContext';

export type TrackAssetBodyProps = {
  children?: React.ReactNode;
  /**
   * expands the body's contents area to fill the entire asset height, minus a
   * small padding at the top and bottom
   */
  fluid?: boolean;
  order?: number;
  style?: React.CSSProperties;
};

const TrackAssetBody: React.FC<TrackAssetBodyProps> = ({
  children,
  fluid = false,
  order,
  style,
}) => {
  const { containerId } = useTrackAssetContext();

  return (
    <div
      id={containerId}
      className={block('track-asset')}
      style={{
        ...style,
        position: 'absolute',
        width: 'auto',
        zIndex: order ?? 'auto',
      }}
    >
      <div className={block('track-asset-inner', { fluid })}>{children}</div>
    </div>
  );
};

export default TrackAssetBody;
